// Shared Golf Elite "glass / wave" design primitives — the ONE source of the
// premium look, used by BOTH the public /signup (GolfEliteSignup) and the
// club-admin login/billing gate (GolfEliteGate) so the two can never drift.
// Exports the scoped CSS (GeGlassStyles) plus the shared hero assets.
// Classes: .ge-page .ge-hero .ge-logo .ge-nav-btn .ge-shell .ge-group .ge-field
// .ge-field-icon .ge-eye .ge-start (+ .ge-auth-* used only by the gate).
import heroBg from '../assets/brand/golf-elite-hero-bg.png'
import heroLogo from '../assets/brand/golf-elite-logo-white.png'

export { heroBg, heroLogo }

export function GeGlassStyles() {
  return (
    <style>{`
      .ge-page { min-height: 100vh; position: relative; overflow-x: hidden; color: #0b2b55;
        background-color: #0a1c45; background-position: center top; background-size: cover; background-repeat: no-repeat;
        font-family: Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; }
      .ge-page * { box-sizing: border-box; }

      .ge-hero { min-height: 205px; padding: 14px 42px 0; position: relative; z-index: 2; }
      .ge-hero-nav { width: 100%; display: flex; align-items: center; gap: 14px; }
      /* Real transparent white Golf Elite logo lockup, rendered directly on the
         hero (no white-background box — the asset is transparent). */
      .ge-logo { width: 330px; max-width: 26vw; height: auto; object-fit: contain; display: block; }

      .ge-nav-btn, .ge-login-btn { height: 48px; padding: 0 20px; display: flex; align-items: center; justify-content: center; gap: 8px;
        color: #fff; background: rgba(7,35,73,0.30); border: 1px solid rgba(255,255,255,0.48); border-radius: 11px;
        font-weight: 700; font-size: 15px; cursor: pointer;
        box-shadow: inset 0 1px 0 rgba(255,255,255,.18), 0 5px 14px rgba(0,25,65,.10);
        backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px);
        transition: transform .15s ease, background .15s ease, border-color .15s ease; }
      .ge-nav-btn:hover, .ge-login-btn:hover { background: rgba(12,49,94,0.50); border-color: rgba(255,255,255,.72); transform: translateY(-1px); }
      .ge-login-btn { margin-left: auto; padding: 0 25px; letter-spacing: .04em; font-weight: 800; }

      .ge-hero-copy { text-align: center; color: #fff; margin: 6px auto 0; padding: 0 20px; }
      .ge-hero-copy h1 { margin: 0; font-size: clamp(34px, 3vw, 46px); line-height: 1.08; font-weight: 800; letter-spacing: -0.025em; text-shadow: 0 3px 16px rgba(0,25,60,0.15); }
      .ge-hero-copy p { margin: 13px 0 0; font-size: 17px; font-weight: 400; color: rgba(255,255,255,.91); text-shadow: 0 2px 8px rgba(0,25,60,.15); }

      .ge-content { position: relative; z-index: 3; width: 100%; padding: 0 16px 60px; margin-top: -3px; }

      .ge-shell { width: min(680px, calc(100vw - 32px)); margin: 0 auto; padding: 17px 22px 22px;
        background: linear-gradient(135deg, rgba(225,240,255,0.38), rgba(205,228,252,0.28));
        border: 1px solid rgba(255,255,255,.78); border-radius: 24px;
        box-shadow: 0 28px 65px rgba(8,37,78,.18), 0 8px 24px rgba(8,48,100,.08), inset 0 1px 0 rgba(255,255,255,.85);
        backdrop-filter: blur(16px) saturate(130%); -webkit-backdrop-filter: blur(16px) saturate(130%); }
      .ge-welcome { text-align:center; font-weight:700; color:#0f2347; background:#e9f1fd; border-radius:12px; padding:10px 14px; margin-bottom:12px; }

      .ge-toggle { display: grid; grid-template-columns: 1fr 1fr; height: 47px; padding: 4px; margin-bottom: 15px;
        background: rgba(255,255,255,.65); border: 1px solid rgba(255,255,255,.84); border-radius: 12px;
        box-shadow: inset 0 1px 0 rgba(255,255,255,.85), 0 5px 16px rgba(10,55,105,.05);
        backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); }
      .ge-opt { border: 0; display: flex; align-items: center; justify-content: center; border-radius: 9px; background: transparent;
        color: #17365d; font-weight: 700; font-size: 15px; cursor: pointer; }
      .ge-opt.active { color: #fff; background: linear-gradient(180deg, #123e78 0%, #082b5c 100%);
        box-shadow: 0 5px 16px rgba(5,50,110,.32), 0 0 11px rgba(36,126,255,.34), inset 0 1px 0 rgba(255,255,255,.14); }

      .ge-plan { padding: 23px 28px 20px; background: rgba(255,255,255,.76); border: 1px solid rgba(255,255,255,.94); border-radius: 16px;
        box-shadow: 0 10px 30px rgba(17,61,110,.07), inset 0 1px 0 rgba(255,255,255,.98);
        backdrop-filter: blur(12px); -webkit-backdrop-filter: blur(12px); }
      .ge-plan-head { display: flex; justify-content: space-between; align-items: flex-start; gap: 20px; }
      .ge-plan-title { margin: 0; color: #0a2b57; font-size: 21px; font-weight: 800; letter-spacing: -0.02em; }
      .ge-price { display: flex; align-items: baseline; white-space: nowrap; color: #0a2b57; }
      .ge-price-main { font-size: 33px; line-height: 1; font-weight: 800; }
      .ge-price-per { margin-left: 3px; color: #4f6580; font-size: 17px; font-weight: 500; }

      .ge-features { margin-top: 14px; padding-top: 12px; border-top: 1px solid rgba(15,58,105,.13); }
      .ge-feature { display: flex; align-items: center; gap: 14px; margin: 9px 0; color: #183858; font-size: 15px; font-weight: 500; }
      .ge-check { width: 23px; height: 23px; flex: 0 0 23px; display: grid; place-items: center; border-radius: 50%; color: #fff;
        background: linear-gradient(180deg, #3286ff 0%, #0c6be9 100%); box-shadow: 0 3px 8px rgba(24,119,242,.20), inset 0 1px 0 rgba(255,255,255,.25); }

      .ge-form { margin-top: 12px; }
      .ge-group { margin-top: 10px; }
      .ge-group label { display: block; margin: 0 0 5px 2px; color: #193d69; font-size: 12px; line-height: 1; font-weight: 800; letter-spacing: .045em; }
      .ge-field-wrap { position: relative; }
      .ge-field { width: 100%; height: 47px; padding: 0 44px 0 48px; color: #14385f; outline: none;
        background: rgba(255,255,255,.70); border: 1px solid rgba(255,255,255,.90); border-radius: 11px;
        box-shadow: inset 0 1px 2px rgba(13,43,78,.035), 0 3px 10px rgba(20,60,100,.04);
        backdrop-filter: blur(10px); -webkit-backdrop-filter: blur(10px);
        font-size: 16px; transition: border-color .15s ease, box-shadow .15s ease, background .15s ease; }
      .ge-field::placeholder { color: #7d96b2; opacity: 1; }
      .ge-field:focus { background: rgba(255,255,255,.85); border-color: rgba(35,116,235,.48);
        box-shadow: 0 0 0 3px rgba(38,120,240,.10), 0 5px 15px rgba(15,70,130,.06); }
      .ge-field-icon { position: absolute; left: 15px; top: 50%; transform: translateY(-50%); display: flex; align-items: center; color: #23486f; pointer-events: none; }
      .ge-eye { position: absolute; right: 12px; top: 50%; transform: translateY(-50%); border: 0; padding: 4px; color: #345777; background: transparent; cursor: pointer; display: flex; align-items: center; }

      .ge-err { color: #b42318; font-weight: 700; font-size: 14px; margin: 6px 2px 0; }

      .ge-start { width: 100%; height: 54px; margin-top: 14px; border: 0; border-radius: 11px; display: flex; align-items: center; justify-content: center; gap: 15px; color: #fff; cursor: pointer;
        background: linear-gradient(135deg, #3282ff 0%, #1670ee 48%, #0758d4 100%);
        font-size: 16px; font-weight: 800; letter-spacing: .025em;
        box-shadow: 0 9px 22px rgba(0,88,220,.28), inset 0 1px 0 rgba(255,255,255,.28); transition: transform .15s ease, box-shadow .15s ease; }
      .ge-start:hover { transform: translateY(-1px); box-shadow: 0 12px 28px rgba(0,88,220,.34), inset 0 1px 0 rgba(255,255,255,.28); }
      .ge-start:disabled { opacity: .6; transform: none; }

      /* Auth (login / billing) — same glass system, narrow centered card. */
      .ge-auth-title { margin: 2px 0 6px; text-align: center; color: #0a2b57; font-size: 24px; font-weight: 800; letter-spacing: -0.02em; }
      .ge-auth-link { text-align: center; margin: 15px 0 2px; color: #274a72; font-size: 14px; font-weight: 500; }
      .ge-auth-link a { color: #0c6be9; font-weight: 800; text-decoration: none; }
      .ge-auth-logout { display: block; width: 100%; margin-top: 10px; background: transparent; border: 0; color: #3a5675; font-size: 13px; font-weight: 700; cursor: pointer; }

      @media (max-width: 900px) {
        .ge-hero { padding-left: 20px; padding-right: 20px; }
        .ge-logo { width: 250px; max-width: 36vw; }
        .ge-nav-btn { padding: 0 13px; }
        .ge-hero-copy { margin-top: 18px; }
      }
      @media (max-width: 650px) {
        .ge-page { background-position: 48% top; }
        .ge-hero { min-height: 220px; padding: 12px 14px 0; }
        .ge-hero-nav { gap: 7px; }
        .ge-logo { width: 170px; max-width: none; }
        .ge-nav-btn, .ge-login-btn { height: 40px; padding: 0 10px; font-size: 13px; }
        .ge-hero-copy { margin-top: 27px; }
        .ge-hero-copy h1 { font-size: 30px; }
        .ge-hero-copy p { font-size: 14px; }
        .ge-shell { padding: 13px; border-radius: 20px; }
        .ge-plan { padding: 19px 17px; }
        .ge-plan-title { font-size: 18px; }
        .ge-price-main { font-size: 27px; }
        .ge-feature { gap: 10px; font-size: 14px; }
      }
    `}</style>
  )
}
